import "./ui.css";
import type { ReactNode } from "react";

export function Card({
  title,
  children,
  className = "",
  bodyClass = "",
}: {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClass?: string;
}) {
  return (
    <section className={`dashboard-card ${className}`}>
      {title && <header className="dashboard-card__title">{title}</header>}
      <div className={`dashboard-card__body ${bodyClass}`}>{children}</div>
    </section>
  );
}
